import { COLORS } from '@/styles/colors';
import styled from 'styled-components';

export const DrawerHeaderBackLine = styled.div`
  padding: 8px 36px;
  background: ${COLORS.grey[200]};
  margin-inline: -36px;
`;
